@let authData = authorisedData$ | async;

<header></header>

<div class="container">
  <h2 class="semi-bold d-md-none">Travelers</h2>
  <h1 class="semi-bold d-none d-md-inline mb-2">Travelers</h1>

  @if (isLoading) {
    <ds-skeleton class="passengers-page-body-item" [height]="80" />
    <ds-skeleton class="passengers-page-body-item" [height]="80" />
    <ds-skeleton class="passengers-page-body-item" [height]="80" />
  } @else {
    @if (authData?.passengers?.length) {
      @for (passenger of authData?.passengers; track passenger) {
        <div
          (click)="navigateToTraveler(passenger.id)"
          class="d-flex align-items-center justify-content-between p-4 cursor-pointer card"
        >
          <div class="d-flex align-items-center">
            <img src="assets/icons/avatar.svg" alt="user" class="avatar" />
            <div class="ml-3 d-flex flex-column">
              <p data-id="full-name">{{ passenger.fullName }}</p>
              <p class="caption" data-id="birthday">{{ passenger.birthday | date }}</p>
            </div>
          </div>
          <img src="assets/icons/keyboard_arrow_right.svg" alt="arrow" />
        </div>
      }
    } @else {
      <h3 data-id="empty">No data</h3>
    }
  }
</div>
